import {getIpAddress} from './getIpAddress';

export const getUserData = ({anuid}, userData) => {
  return {
    user_data: {
      client_ip_address: getIpAddress(),
      client_user_agent: navigator.userAgent,
      external_id: anuid,
      ...userData
    }
  };
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/getUserData.js